import React from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import Grid from '@mui/material/Grid2';
import { Box, Button } from '@mui/material';

import validationSchema from 'src/utils/validationSchema';

import { useTranslate } from 'src/locales';

import { Form, Field } from 'src/components/hook-form';

import { useChannelContext } from '../../hooks';

export default function VoiceStep1() {
  const { handleChannelName, state: channelState, onChangeStep } = useChannelContext();

  const { t } = useTranslate('translation');

  type VoiceCallField = { channelName: string };

  const fldList = [{ name: 'channelName', required: true }];

  const CampaignSchema = validationSchema(fldList, t);

  const defaultValues: VoiceCallField = {
    channelName: '',
  };

  const methods = useForm<VoiceCallField>({
    mode: 'all',
    resolver: zodResolver(CampaignSchema),
    defaultValues,
    values: { channelName: channelState.channelName },
  });

  const { reset, handleSubmit, watch } = methods;

  const channelName = watch('channelName');

  const onSubmit = handleSubmit(async (data) => {
    handleChannelName(data.channelName);
    reset();
  });

  return (
    <Form methods={methods} onSubmit={onSubmit} style={{ height: '100%' }}>
      <Box sx={{ height: '90%', display: 'flex', flexDirection: 'column' }}>
        <Box>
          <Grid container spacing={3} justifyContent="space-between">
            <Field.Text
              name="channelName"
              label={t('CHANNEL_NAME')}
              slotProps={{ inputLabel: { shrink: true } }}
              placeholder={t('CHANNEL_NAME')}
            />
          </Grid>
        </Box>

        <Box sx={{ flexGrow: 1 }} />
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            justifyContent: 'flex-end',
            alignItems: 'center',
            my: 2,
          }}
        >
          <Box>
            <Button variant="outlined" color="inherit" onClick={() => onChangeStep('back')}>
              {t('PREVIOUS')}
            </Button>
          </Box>
          <Box>
            <Button
              disabled={!channelName}
              size="small"
              variant="contained"
              type="submit"
              onClick={() => onChangeStep('next')}
            >
              {t('NEXT')}
            </Button>
          </Box>
        </Box>
      </Box>
    </Form>
  );
}
